unit View.Areceber.List;

interface

uses
  System.SysUtils, System.Classes, WEBLib.Graphics, WEBLib.Forms, WEBLib.Dialogs,
  Vcl.Controls, Vcl.StdCtrls, Math,

  WEBLib.StdCtrls, Web, JS, WEBLib.Lists,

  App.Types, WEBLib.Controls, WEBLib.Grids, Data.DB,
  XData.Web.Dataset, WEBLib.DBCtrls, WEBLib.DB, WEBLib.ExtCtrls,

  XData.Web.JsonDataset,

  Grid.Plugins,
  Crud.Utils, UConstantes, UUtils;

type
  TFViewAreceberList = class(TForm)
    btNew: TButton;
    AreceberDataset: TXDataWebDataSet;
    AreceberDatasetid: TIntegerField;
    AreceberDatasetaliado_id: TIntegerField;
    AreceberDatasetdata_base_id: TIntegerField;
    AreceberDatasetcliente_id: TIntegerField;
    AreceberDatasetdocumento: TStringField;
    AreceberDatasetparcela: TStringField;
    AreceberDatasetemissao: TDateTimeField;
    AreceberDatasetvencimento: TDateTimeField;
    AreceberDatasetpagamento: TDateTimeField;
    AreceberDatasetvenda_id: TIntegerField;
    AreceberDatasetcupons_id: TIntegerField;
    AreceberDatasetvalor_total: TFloatField;
    AreceberDatasetvalor_saldo_pendente: TFloatField;
    AreceberDatasetvalor_pago: TFloatField;
    AreceberDatasetmodalidade_id: TIntegerField;
    AreceberDatasetareceber_comissao: TBooleanField;
    AreceberDatasetstatus_id: TIntegerField;
    AreceberDatasetobservacao: TStringField;
    AreceberDatasetfuncionario_id: TIntegerField;
    AreceberDatasetconhecimento_transporte_id: TIntegerField;
    AreceberDatasetareceber_credito: TBooleanField;
    AreceberDatasetdevolucao_id: TIntegerField;
    AreceberDatasetrenegociacao_id: TIntegerField;
    AreceberDatasetvenda_servico_id: TIntegerField;
    AreceberDatasetoperadora_cartao_id: TIntegerField;
    AreceberDatasetnsu_documento: TStringField;
    AreceberDatasetcheque_pendente: TBooleanField;
    AreceberDatasetvalor_juros_pendente: TFloatField;
    AreceberDatasetstatus_crediario_id: TIntegerField;
    AreceberDatasetmensalidade_id: TIntegerField;
    AreceberDatasetcredito_utilizado: TBooleanField;
    AreceberDatasetcodigo_interno: TIntegerField;
    AreceberDatasetexcluido: TBooleanField;
    AreceberDatasetinclusao: TDateTimeField;
    AreceberDatasetalteracao: TDateTimeField;
    AreceberDatasetexclusao: TDateTimeField;
    WebDBTableControl1: TDBTableControl;
    WebDataSource: TDataSource;
    cbPageSize: TComboBox;
    edSearch: TEdit;
    lbPaginationInfo: TLabel;
    lcPaginator: TListControl;
    tmrConsulta: TTimer;
    procedure WebFormCreate(Sender: TObject);
    procedure btNewClick(Sender: TObject);
    procedure WebDBTableControl1GetCellChildren(Sender: TObject; ACol,
      ARow: Integer; AField: TField; AValue: string; AElement: TJSHTMLElementRecord);
    procedure cbPageSizeChange(Sender: TObject);
    procedure edSearchKeyDown(Sender: TObject; var Key: Word;
      Shift: TShiftState);
    procedure edSearchKeyUp(Sender: TObject; var Key: Word; Shift: TShiftState);
    procedure tmrConsultaTimer(Sender: TObject);
  private
    FEditProc: TEditProc;
    FGridPlugin: TGridPlugin;
  public
    class function CreateForm(AElementID: string; AShowEditProc: TEditProc): TForm;
  protected procedure LoadDFMValues; override; end;

var
  FViewAreceberList: TFViewAreceberList;

implementation

uses
  ConnectionModule;

{$R *.dfm}

{ TFViewAreceberList }

procedure TFViewAreceberList.cbPageSizeChange(Sender: TObject);
begin
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text), True);
end;

class function TFViewAreceberList.CreateForm(AElementID: string;
  AShowEditProc: TEditProc): TForm;

  procedure AfterCreate(AForm: TObject);
  begin
    TFViewAreceberList(AForm).FEditProc := AShowEditProc;
  end;

begin
  Application.CreateForm(TFViewAreceberList, AElementID, Result, @AfterCreate);
end;

procedure TFViewAreceberList.edSearchKeyDown(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Enabled := False;

  if Key = 13 then
    FGridPlugin.SetFilterText(edSearch.Text, True);
end;

procedure TFViewAreceberList.edSearchKeyUp(Sender: TObject; var Key: Word;
  Shift: TShiftState);
begin
  tmrConsulta.Interval := FTimerConsulta;
  tmrConsulta.Enabled := True;
end;

procedure TFViewAreceberList.tmrConsultaTimer(Sender: TObject);
begin
  FGridPlugin.SetFilterText(edSearch.Text, True);

  tmrConsulta.Enabled := False;
  tmrConsulta.Interval := FTimerConsulta;
end;

procedure TFViewAreceberList.btNewClick(Sender: TObject);
begin
  FEditProc( nil );
end;

procedure TFViewAreceberList.WebDBTableControl1GetCellChildren(Sender: TObject;
  ACol, ARow: Integer; AField: TField; AValue: string;
  AElement: TJSHTMLElementRecord);
var
  RecordId: JSValue;

  procedure EditButtonClick(Sender: TObject);
  begin
    FEditProc(RecordId);
  end;

var
  Button: TButton;
begin
  if ARow = 0 then
    Exit;

  if WebDBTableControl1.Columns[ACol].Title = 'Actions' then
  begin
    RecordId := TCrudUtils.GetIdFromObject(
      AreceberDataset.Connection.Model.DefaultSchema.FindEntityType(AreceberDataset.EntitySetName),
      AreceberDataset.CurrentData
    );
    Button := TButton.Create(nil);
    Button.Caption := 'Edit';
    Button.OnClick := @EditButtonClick;
    Button.ElementClassName := 'btn btn-outline btn-default btn-xs';
    Button.ParentElement := AElement.element;
    Button.WidthStyle := TSizeStyle.ssAuto;
    Button.HeightStyle := TSizeStyle.ssAuto;
  end;
end;

procedure TFViewAreceberList.WebFormCreate(Sender: TObject);
begin
  TUtils.SetValorDicionarioClasses('areceber', 'active');
  TUtils.SetValorDicionarioClasses('recebimentos_collapse', 'show');
  TUtils.SetValorDicionarioClasses('menu_recebimentos', 'active');
  TUtils.SetPaginaSelecionada;

  FGridPlugin := TGridPlugin.Create(
    WebDBTableControl1,
    AreceberDataset,
    lcPaginator,
    lbPaginationInfo
  );
  FGridPlugin.SetPageSize(StrToInt(cbPageSize.Text));
  FGridPlugin.SetFilterText(edSearch.Text);
  FGridPlugin.Load;
end;

procedure TFViewAreceberList.LoadDFMValues;
begin
  inherited LoadDFMValues;

  lbPaginationInfo := TLabel.Create('view.areceber.list.pagination.info');
  btNew := TButton.Create('view.areceber.list.newbutton');
  WebDBTableControl1 := TDBTableControl.Create('view.areceber.list.table');
  cbPageSize := TComboBox.Create('view.areceber.list.cbPageSize');
  edSearch := TEdit.Create('view.areceber.list.search');
  lcPaginator := TListControl.Create('view.areceber.list.pagination');
  AreceberDataset := TXDataWebDataSet.Create(Self);
  AreceberDatasetid := TIntegerField.Create(Self);
  AreceberDatasetaliado_id := TIntegerField.Create(Self);
  AreceberDatasetdata_base_id := TIntegerField.Create(Self);
  AreceberDatasetcliente_id := TIntegerField.Create(Self);
  AreceberDatasetdocumento := TStringField.Create(Self);
  AreceberDatasetparcela := TStringField.Create(Self);
  AreceberDatasetemissao := TDateTimeField.Create(Self);
  AreceberDatasetvencimento := TDateTimeField.Create(Self);
  AreceberDatasetpagamento := TDateTimeField.Create(Self);
  AreceberDatasetvenda_id := TIntegerField.Create(Self);
  AreceberDatasetcupons_id := TIntegerField.Create(Self);
  AreceberDatasetvalor_total := TFloatField.Create(Self);
  AreceberDatasetvalor_saldo_pendente := TFloatField.Create(Self);
  AreceberDatasetvalor_pago := TFloatField.Create(Self);
  AreceberDatasetmodalidade_id := TIntegerField.Create(Self);
  AreceberDatasetareceber_comissao := TBooleanField.Create(Self);
  AreceberDatasetstatus_id := TIntegerField.Create(Self);
  AreceberDatasetobservacao := TStringField.Create(Self);
  AreceberDatasetfuncionario_id := TIntegerField.Create(Self);
  AreceberDatasetconhecimento_transporte_id := TIntegerField.Create(Self);
  AreceberDatasetareceber_credito := TBooleanField.Create(Self);
  AreceberDatasetdevolucao_id := TIntegerField.Create(Self);
  AreceberDatasetrenegociacao_id := TIntegerField.Create(Self);
  AreceberDatasetvenda_servico_id := TIntegerField.Create(Self);
  AreceberDatasetoperadora_cartao_id := TIntegerField.Create(Self);
  AreceberDatasetnsu_documento := TStringField.Create(Self);
  AreceberDatasetcheque_pendente := TBooleanField.Create(Self);
  AreceberDatasetvalor_juros_pendente := TFloatField.Create(Self);
  AreceberDatasetstatus_crediario_id := TIntegerField.Create(Self);
  AreceberDatasetmensalidade_id := TIntegerField.Create(Self);
  AreceberDatasetcredito_utilizado := TBooleanField.Create(Self);
  AreceberDatasetcodigo_interno := TIntegerField.Create(Self);
  AreceberDatasetexcluido := TBooleanField.Create(Self);
  AreceberDatasetinclusao := TDateTimeField.Create(Self);
  AreceberDatasetalteracao := TDateTimeField.Create(Self);
  AreceberDatasetexclusao := TDateTimeField.Create(Self);
  WebDataSource := TDataSource.Create(Self);
  tmrConsulta := TTimer.Create(Self);

  lbPaginationInfo.BeforeLoadDFMValues;
  btNew.BeforeLoadDFMValues;
  WebDBTableControl1.BeforeLoadDFMValues;
  cbPageSize.BeforeLoadDFMValues;
  edSearch.BeforeLoadDFMValues;
  lcPaginator.BeforeLoadDFMValues;
  AreceberDataset.BeforeLoadDFMValues;
  AreceberDatasetid.BeforeLoadDFMValues;
  AreceberDatasetaliado_id.BeforeLoadDFMValues;
  AreceberDatasetdata_base_id.BeforeLoadDFMValues;
  AreceberDatasetcliente_id.BeforeLoadDFMValues;
  AreceberDatasetdocumento.BeforeLoadDFMValues;
  AreceberDatasetparcela.BeforeLoadDFMValues;
  AreceberDatasetemissao.BeforeLoadDFMValues;
  AreceberDatasetvencimento.BeforeLoadDFMValues;
  AreceberDatasetpagamento.BeforeLoadDFMValues;
  AreceberDatasetvenda_id.BeforeLoadDFMValues;
  AreceberDatasetcupons_id.BeforeLoadDFMValues;
  AreceberDatasetvalor_total.BeforeLoadDFMValues;
  AreceberDatasetvalor_saldo_pendente.BeforeLoadDFMValues;
  AreceberDatasetvalor_pago.BeforeLoadDFMValues;
  AreceberDatasetmodalidade_id.BeforeLoadDFMValues;
  AreceberDatasetareceber_comissao.BeforeLoadDFMValues;
  AreceberDatasetstatus_id.BeforeLoadDFMValues;
  AreceberDatasetobservacao.BeforeLoadDFMValues;
  AreceberDatasetfuncionario_id.BeforeLoadDFMValues;
  AreceberDatasetconhecimento_transporte_id.BeforeLoadDFMValues;
  AreceberDatasetareceber_credito.BeforeLoadDFMValues;
  AreceberDatasetdevolucao_id.BeforeLoadDFMValues;
  AreceberDatasetrenegociacao_id.BeforeLoadDFMValues;
  AreceberDatasetvenda_servico_id.BeforeLoadDFMValues;
  AreceberDatasetoperadora_cartao_id.BeforeLoadDFMValues;
  AreceberDatasetnsu_documento.BeforeLoadDFMValues;
  AreceberDatasetcheque_pendente.BeforeLoadDFMValues;
  AreceberDatasetvalor_juros_pendente.BeforeLoadDFMValues;
  AreceberDatasetstatus_crediario_id.BeforeLoadDFMValues;
  AreceberDatasetmensalidade_id.BeforeLoadDFMValues;
  AreceberDatasetcredito_utilizado.BeforeLoadDFMValues;
  AreceberDatasetcodigo_interno.BeforeLoadDFMValues;
  AreceberDatasetexcluido.BeforeLoadDFMValues;
  AreceberDatasetinclusao.BeforeLoadDFMValues;
  AreceberDatasetalteracao.BeforeLoadDFMValues;
  AreceberDatasetexclusao.BeforeLoadDFMValues;
  WebDataSource.BeforeLoadDFMValues;
  tmrConsulta.BeforeLoadDFMValues;
  try
    Name := 'FViewAreceberList';
    Width := 695;
    Height := 500;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -11;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    lbPaginationInfo.SetParentComponent(Self);
    lbPaginationInfo.Name := 'lbPaginationInfo';
    lbPaginationInfo.Left := 8;
    lbPaginationInfo.Top := 376;
    lbPaginationInfo.Width := 141;
    lbPaginationInfo.Height := 13;
    lbPaginationInfo.Caption := 'Showing 1 to 10 of 57 entries';
    lbPaginationInfo.HeightPercent := 100.000000000000000000;
    lbPaginationInfo.WidthPercent := 100.000000000000000000;
    btNew.SetParentComponent(Self);
    btNew.Name := 'btNew';
    btNew.Left := 8;
    btNew.Top := 8;
    btNew.Width := 50;
    btNew.Height := 25;
    btNew.Caption := 'New';
    btNew.HeightPercent := 100.000000000000000000;
    btNew.WidthPercent := 100.000000000000000000;
    SetEvent(btNew, Self, 'OnClick', 'btNewClick');
    WebDBTableControl1.SetParentComponent(Self);
    WebDBTableControl1.Name := 'WebDBTableControl1';
    WebDBTableControl1.Left := 8;
    WebDBTableControl1.Top := 94;
    WebDBTableControl1.Width := 521;
    WebDBTableControl1.Height := 265;
    WebDBTableControl1.ElementClassName := 'table-responsive';
    WebDBTableControl1.BorderColor := clSilver;
    WebDBTableControl1.ColHeader := False;
    WebDBTableControl1.ElementTableClassName := 'table table-striped table-bordered table-hover dataTable';
    SetEvent(WebDBTableControl1, Self, 'OnGetCellChildren', 'WebDBTableControl1GetCellChildren');
    WebDBTableControl1.Columns.Clear;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'id';
      Title := 'id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'aliado_id';
      Title := 'aliado_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'data_base_id';
      Title := 'data_base_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cliente_id';
      Title := 'cliente_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'documento';
      Title := 'documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'parcela';
      Title := 'parcela';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'emissao';
      Title := 'emissao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'vencimento';
      Title := 'vencimento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'pagamento';
      Title := 'pagamento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'venda_id';
      Title := 'venda_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cupons_id';
      Title := 'cupons_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_total';
      Title := 'valor_total';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_saldo_pendente';
      Title := 'valor_saldo_pendente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_pago';
      Title := 'valor_pago';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'modalidade_id';
      Title := 'modalidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'areceber_comissao';
      Title := 'areceber_comissao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status_id';
      Title := 'status_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'observacao';
      Title := 'observacao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'funcionario_id';
      Title := 'funcionario_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'conhecimento_transporte_id';
      Title := 'conhecimento_transporte_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'areceber_credito';
      Title := 'areceber_credito';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'devolucao_id';
      Title := 'devolucao_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'renegociacao_id';
      Title := 'renegociacao_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'venda_servico_id';
      Title := 'venda_servico_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'operadora_cartao_id';
      Title := 'operadora_cartao_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'nsu_documento';
      Title := 'nsu_documento';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'cheque_pendente';
      Title := 'cheque_pendente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'valor_juros_pendente';
      Title := 'valor_juros_pendente';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'status_crediario_id';
      Title := 'status_crediario_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'mensalidade_id';
      Title := 'mensalidade_id';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'credito_utilizado';
      Title := 'credito_utilizado';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'codigo_interno';
      Title := 'codigo_interno';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'excluido';
      Title := 'excluido';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'inclusao';
      Title := 'inclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'alteracao';
      Title := 'alteracao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      DataField := 'exclusao';
      Title := 'exclusao';
    end;
    with WebDBTableControl1.Columns.Add do
    begin
      Title := 'Actions';
    end;
    WebDBTableControl1.DataSource := WebDataSource;
    cbPageSize.SetParentComponent(Self);
    cbPageSize.Name := 'cbPageSize';
    cbPageSize.Left := 8;
    cbPageSize.Top := 67;
    cbPageSize.Width := 81;
    cbPageSize.Height := 21;
    cbPageSize.HeightPercent := 100.000000000000000000;
    cbPageSize.TabOrder := 2;
    cbPageSize.Text := '10';
    cbPageSize.WidthPercent := 100.000000000000000000;
    SetEvent(cbPageSize, Self, 'OnChange', 'cbPageSizeChange');
    cbPageSize.ItemIndex := 0;
    cbPageSize.Items.BeginUpdate;
    try
      cbPageSize.Items.Clear;
      cbPageSize.Items.Add('10');
      cbPageSize.Items.Add('25');
      cbPageSize.Items.Add('50');
      cbPageSize.Items.Add('100');
    finally
      cbPageSize.Items.EndUpdate;
    end;
    edSearch.SetParentComponent(Self);
    edSearch.Name := 'edSearch';
    edSearch.Left := 408;
    edSearch.Top := 67;
    edSearch.Width := 121;
    edSearch.Height := 21;
    edSearch.HeightPercent := 100.000000000000000000;
    edSearch.TabOrder := 3;
    edSearch.WidthPercent := 100.000000000000000000;
    SetEvent(edSearch, Self, 'OnKeyDown', 'edSearchKeyDown');
    SetEvent(edSearch, Self, 'OnKeyUp', 'edSearchKeyUp');
    lcPaginator.SetParentComponent(Self);
    lcPaginator.Name := 'lcPaginator';
    lcPaginator.Left := 240;
    lcPaginator.Top := 365;
    lcPaginator.Width := 289;
    lcPaginator.Height := 25;
    lcPaginator.HeightPercent := 100.000000000000000000;
    lcPaginator.WidthPercent := 100.000000000000000000;
    lcPaginator.DefaultItemClassName := 'page-item';
    lcPaginator.DefaultItemLinkClassName := 'page-link';
    lcPaginator.ElementListClassName := 'pagination';
    lcPaginator.Style := lsPagination;
    AreceberDataset.SetParentComponent(Self);
    AreceberDataset.Name := 'AreceberDataset';
    AreceberDataset.EntitySetName := 'Areceber';
    AreceberDataset.Connection := DMConnection.ApiConnection;
    AreceberDataset.Left := 72;
    AreceberDataset.Top := 144;
    AreceberDatasetid.SetParentComponent(AreceberDataset);
    AreceberDatasetid.Name := 'AreceberDatasetid';
    AreceberDatasetid.FieldName := 'id';
    AreceberDatasetid.Required := True;
    AreceberDatasetaliado_id.SetParentComponent(AreceberDataset);
    AreceberDatasetaliado_id.Name := 'AreceberDatasetaliado_id';
    AreceberDatasetaliado_id.FieldName := 'aliado_id';
    AreceberDatasetaliado_id.Required := True;
    AreceberDatasetdata_base_id.SetParentComponent(AreceberDataset);
    AreceberDatasetdata_base_id.Name := 'AreceberDatasetdata_base_id';
    AreceberDatasetdata_base_id.FieldName := 'data_base_id';
    AreceberDatasetdata_base_id.Required := True;
    AreceberDatasetcliente_id.SetParentComponent(AreceberDataset);
    AreceberDatasetcliente_id.Name := 'AreceberDatasetcliente_id';
    AreceberDatasetcliente_id.FieldName := 'cliente_id';
    AreceberDatasetdocumento.SetParentComponent(AreceberDataset);
    AreceberDatasetdocumento.Name := 'AreceberDatasetdocumento';
    AreceberDatasetdocumento.FieldName := 'documento';
    AreceberDatasetdocumento.Size := 255;
    AreceberDatasetparcela.SetParentComponent(AreceberDataset);
    AreceberDatasetparcela.Name := 'AreceberDatasetparcela';
    AreceberDatasetparcela.FieldName := 'parcela';
    AreceberDatasetparcela.Size := 255;
    AreceberDatasetemissao.SetParentComponent(AreceberDataset);
    AreceberDatasetemissao.Name := 'AreceberDatasetemissao';
    AreceberDatasetemissao.FieldName := 'emissao';
    AreceberDatasetvencimento.SetParentComponent(AreceberDataset);
    AreceberDatasetvencimento.Name := 'AreceberDatasetvencimento';
    AreceberDatasetvencimento.FieldName := 'vencimento';
    AreceberDatasetvencimento.Required := True;
    AreceberDatasetpagamento.SetParentComponent(AreceberDataset);
    AreceberDatasetpagamento.Name := 'AreceberDatasetpagamento';
    AreceberDatasetpagamento.FieldName := 'pagamento';
    AreceberDatasetvenda_id.SetParentComponent(AreceberDataset);
    AreceberDatasetvenda_id.Name := 'AreceberDatasetvenda_id';
    AreceberDatasetvenda_id.FieldName := 'venda_id';
    AreceberDatasetcupons_id.SetParentComponent(AreceberDataset);
    AreceberDatasetcupons_id.Name := 'AreceberDatasetcupons_id';
    AreceberDatasetcupons_id.FieldName := 'cupons_id';
    AreceberDatasetvalor_total.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_total.Name := 'AreceberDatasetvalor_total';
    AreceberDatasetvalor_total.FieldName := 'valor_total';
    AreceberDatasetvalor_total.Required := True;
    AreceberDatasetvalor_saldo_pendente.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_saldo_pendente.Name := 'AreceberDatasetvalor_saldo_pendente';
    AreceberDatasetvalor_saldo_pendente.FieldName := 'valor_saldo_pendente';
    AreceberDatasetvalor_pago.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_pago.Name := 'AreceberDatasetvalor_pago';
    AreceberDatasetvalor_pago.FieldName := 'valor_pago';
    AreceberDatasetmodalidade_id.SetParentComponent(AreceberDataset);
    AreceberDatasetmodalidade_id.Name := 'AreceberDatasetmodalidade_id';
    AreceberDatasetmodalidade_id.FieldName := 'modalidade_id';
    AreceberDatasetmodalidade_id.Required := True;
    AreceberDatasetareceber_comissao.SetParentComponent(AreceberDataset);
    AreceberDatasetareceber_comissao.Name := 'AreceberDatasetareceber_comissao';
    AreceberDatasetareceber_comissao.FieldName := 'areceber_comissao';
    AreceberDatasetareceber_comissao.Required := True;
    AreceberDatasetstatus_id.SetParentComponent(AreceberDataset);
    AreceberDatasetstatus_id.Name := 'AreceberDatasetstatus_id';
    AreceberDatasetstatus_id.FieldName := 'status_id';
    AreceberDatasetobservacao.SetParentComponent(AreceberDataset);
    AreceberDatasetobservacao.Name := 'AreceberDatasetobservacao';
    AreceberDatasetobservacao.FieldName := 'observacao';
    AreceberDatasetobservacao.Size := 255;
    AreceberDatasetfuncionario_id.SetParentComponent(AreceberDataset);
    AreceberDatasetfuncionario_id.Name := 'AreceberDatasetfuncionario_id';
    AreceberDatasetfuncionario_id.FieldName := 'funcionario_id';
    AreceberDatasetconhecimento_transporte_id.SetParentComponent(AreceberDataset);
    AreceberDatasetconhecimento_transporte_id.Name := 'AreceberDatasetconhecimento_transporte_id';
    AreceberDatasetconhecimento_transporte_id.FieldName := 'conhecimento_transporte_id';
    AreceberDatasetareceber_credito.SetParentComponent(AreceberDataset);
    AreceberDatasetareceber_credito.Name := 'AreceberDatasetareceber_credito';
    AreceberDatasetareceber_credito.FieldName := 'areceber_credito';
    AreceberDatasetareceber_credito.Required := True;
    AreceberDatasetdevolucao_id.SetParentComponent(AreceberDataset);
    AreceberDatasetdevolucao_id.Name := 'AreceberDatasetdevolucao_id';
    AreceberDatasetdevolucao_id.FieldName := 'devolucao_id';
    AreceberDatasetrenegociacao_id.SetParentComponent(AreceberDataset);
    AreceberDatasetrenegociacao_id.Name := 'AreceberDatasetrenegociacao_id';
    AreceberDatasetrenegociacao_id.FieldName := 'renegociacao_id';
    AreceberDatasetvenda_servico_id.SetParentComponent(AreceberDataset);
    AreceberDatasetvenda_servico_id.Name := 'AreceberDatasetvenda_servico_id';
    AreceberDatasetvenda_servico_id.FieldName := 'venda_servico_id';
    AreceberDatasetoperadora_cartao_id.SetParentComponent(AreceberDataset);
    AreceberDatasetoperadora_cartao_id.Name := 'AreceberDatasetoperadora_cartao_id';
    AreceberDatasetoperadora_cartao_id.FieldName := 'operadora_cartao_id';
    AreceberDatasetnsu_documento.SetParentComponent(AreceberDataset);
    AreceberDatasetnsu_documento.Name := 'AreceberDatasetnsu_documento';
    AreceberDatasetnsu_documento.FieldName := 'nsu_documento';
    AreceberDatasetnsu_documento.Size := 255;
    AreceberDatasetcheque_pendente.SetParentComponent(AreceberDataset);
    AreceberDatasetcheque_pendente.Name := 'AreceberDatasetcheque_pendente';
    AreceberDatasetcheque_pendente.FieldName := 'cheque_pendente';
    AreceberDatasetcheque_pendente.Required := True;
    AreceberDatasetvalor_juros_pendente.SetParentComponent(AreceberDataset);
    AreceberDatasetvalor_juros_pendente.Name := 'AreceberDatasetvalor_juros_pendente';
    AreceberDatasetvalor_juros_pendente.FieldName := 'valor_juros_pendente';
    AreceberDatasetstatus_crediario_id.SetParentComponent(AreceberDataset);
    AreceberDatasetstatus_crediario_id.Name := 'AreceberDatasetstatus_crediario_id';
    AreceberDatasetstatus_crediario_id.FieldName := 'status_crediario_id';
    AreceberDatasetmensalidade_id.SetParentComponent(AreceberDataset);
    AreceberDatasetmensalidade_id.Name := 'AreceberDatasetmensalidade_id';
    AreceberDatasetmensalidade_id.FieldName := 'mensalidade_id';
    AreceberDatasetcredito_utilizado.SetParentComponent(AreceberDataset);
    AreceberDatasetcredito_utilizado.Name := 'AreceberDatasetcredito_utilizado';
    AreceberDatasetcredito_utilizado.FieldName := 'credito_utilizado';
    AreceberDatasetcredito_utilizado.Required := True;
    AreceberDatasetcodigo_interno.SetParentComponent(AreceberDataset);
    AreceberDatasetcodigo_interno.Name := 'AreceberDatasetcodigo_interno';
    AreceberDatasetcodigo_interno.FieldName := 'codigo_interno';
    AreceberDatasetcodigo_interno.Required := True;
    AreceberDatasetexcluido.SetParentComponent(AreceberDataset);
    AreceberDatasetexcluido.Name := 'AreceberDatasetexcluido';
    AreceberDatasetexcluido.FieldName := 'excluido';
    AreceberDatasetinclusao.SetParentComponent(AreceberDataset);
    AreceberDatasetinclusao.Name := 'AreceberDatasetinclusao';
    AreceberDatasetinclusao.FieldName := 'inclusao';
    AreceberDatasetalteracao.SetParentComponent(AreceberDataset);
    AreceberDatasetalteracao.Name := 'AreceberDatasetalteracao';
    AreceberDatasetalteracao.FieldName := 'alteracao';
    AreceberDatasetexclusao.SetParentComponent(AreceberDataset);
    AreceberDatasetexclusao.Name := 'AreceberDatasetexclusao';
    AreceberDatasetexclusao.FieldName := 'exclusao';
    WebDataSource.SetParentComponent(Self);
    WebDataSource.Name := 'WebDataSource';
    WebDataSource.DataSet := AreceberDataset;
    WebDataSource.Left := 72;
    WebDataSource.Top := 200;
    tmrConsulta.SetParentComponent(Self);
    tmrConsulta.Name := 'tmrConsulta';
    tmrConsulta.Enabled := False;
    SetEvent(tmrConsulta, Self, 'OnTimer', 'tmrConsultaTimer');
    tmrConsulta.Left := 616;
    tmrConsulta.Top := 344;
  finally
    lbPaginationInfo.AfterLoadDFMValues;
    btNew.AfterLoadDFMValues;
    WebDBTableControl1.AfterLoadDFMValues;
    cbPageSize.AfterLoadDFMValues;
    edSearch.AfterLoadDFMValues;
    lcPaginator.AfterLoadDFMValues;
    AreceberDataset.AfterLoadDFMValues;
    AreceberDatasetid.AfterLoadDFMValues;
    AreceberDatasetaliado_id.AfterLoadDFMValues;
    AreceberDatasetdata_base_id.AfterLoadDFMValues;
    AreceberDatasetcliente_id.AfterLoadDFMValues;
    AreceberDatasetdocumento.AfterLoadDFMValues;
    AreceberDatasetparcela.AfterLoadDFMValues;
    AreceberDatasetemissao.AfterLoadDFMValues;
    AreceberDatasetvencimento.AfterLoadDFMValues;
    AreceberDatasetpagamento.AfterLoadDFMValues;
    AreceberDatasetvenda_id.AfterLoadDFMValues;
    AreceberDatasetcupons_id.AfterLoadDFMValues;
    AreceberDatasetvalor_total.AfterLoadDFMValues;
    AreceberDatasetvalor_saldo_pendente.AfterLoadDFMValues;
    AreceberDatasetvalor_pago.AfterLoadDFMValues;
    AreceberDatasetmodalidade_id.AfterLoadDFMValues;
    AreceberDatasetareceber_comissao.AfterLoadDFMValues;
    AreceberDatasetstatus_id.AfterLoadDFMValues;
    AreceberDatasetobservacao.AfterLoadDFMValues;
    AreceberDatasetfuncionario_id.AfterLoadDFMValues;
    AreceberDatasetconhecimento_transporte_id.AfterLoadDFMValues;
    AreceberDatasetareceber_credito.AfterLoadDFMValues;
    AreceberDatasetdevolucao_id.AfterLoadDFMValues;
    AreceberDatasetrenegociacao_id.AfterLoadDFMValues;
    AreceberDatasetvenda_servico_id.AfterLoadDFMValues;
    AreceberDatasetoperadora_cartao_id.AfterLoadDFMValues;
    AreceberDatasetnsu_documento.AfterLoadDFMValues;
    AreceberDatasetcheque_pendente.AfterLoadDFMValues;
    AreceberDatasetvalor_juros_pendente.AfterLoadDFMValues;
    AreceberDatasetstatus_crediario_id.AfterLoadDFMValues;
    AreceberDatasetmensalidade_id.AfterLoadDFMValues;
    AreceberDatasetcredito_utilizado.AfterLoadDFMValues;
    AreceberDatasetcodigo_interno.AfterLoadDFMValues;
    AreceberDatasetexcluido.AfterLoadDFMValues;
    AreceberDatasetinclusao.AfterLoadDFMValues;
    AreceberDatasetalteracao.AfterLoadDFMValues;
    AreceberDatasetexclusao.AfterLoadDFMValues;
    WebDataSource.AfterLoadDFMValues;
    tmrConsulta.AfterLoadDFMValues;
  end;
end;

end.
